<template>
  <v-layout wrap>
    <v-expansion-panel
      v-for="column in data.filter(item => item.tasks.length)"
      expand
      :key="column.name"
      v-model="column.is_opened"
      class="mb-1"
    >
      <v-expansion-panel-content>
        <template v-slot:header>
          <h2>{{ column.name }}</h2>
        </template>
        <v-list class="tasks_page__list" v-if="isDesktop">
          <template v-for="(task, index) in column.tasks">
            <v-list-tile
              class="tasks_page__list--item"
              :to="{ name: 'tasks-form', params: {project_id: task.project_id, task_id: task.id }}"
              tag="a"
              :key="index"
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  <div>
                    <div class="tasks_page__list--item_chip">{{ task.short_name.toUpperCase() }}</div>
                    <nested-icons :task="task"></nested-icons>
                    <span class="body-1">{{ task.title }}</span>
                    <div
                      v-if="task.labels && task.labels.length"
                      class="tasks_page__list--item_labels"
                    >
                      <div
                        v-for="label in task.labels"
                        :key="label.name"
                        class="tasks_page__list--item_chip"
                        :style="{ color: label.text_color, 'background-color': label.color}"
                      >
                        {{ label.name }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div v-if="task.instance_users && task.instance_users.length">
                      <v-btn
                        color="primary"
                        icon
                        small
                        v-for="user in task.instance_users"
                        :key="user.id"
                      >
                        {{ user.short_name }}
                      </v-btn>
                    </div>
                  </div>
                </v-list-tile-title>
              </v-list-tile-content>
              <v-btn v-if="!task.deleted_at" title="Archive" @click.stop.prevent="openRemoveModal(task)" class="my-0" color="secondary" small icon>
                <v-icon color="accent">archive</v-icon>
              </v-btn>
              <v-btn v-if="task.deleted_at" small icon title="Restore" color="success" @click.stop.prevent="restoreTask(task)">
                <v-icon size="18">restore</v-icon>
              </v-btn>
            </v-list-tile>
            <v-divider v-if="index != column.tasks.length - 1"></v-divider>
          </template>
        </v-list>
        <div v-else class="mobile_tasks">
          <router-link
            tag="div"
            class="pa-1 px-2"
            v-for="(task, index) in column.tasks"
            :to="{ name: 'tasks-form', params: {project_id: task.project_id, task_id: task.id }}"
            :key="index"
          >
            <v-card>
              <v-layout row>
                <v-flex xs9>
                  <v-card-title primary-title class="pt-1">
                    <div>
                      <div class="headline">{{ task.title }}</div>
                      <v-chip small color="success" text-color="white">{{ task.short_name.toUpperCase() }}</v-chip>
                    </div>
                  </v-card-title>
                </v-flex>
                <v-flex v-if="task.instance_users && task.instance_users.length" xs3 class="text-xs-right">
                  <v-btn icon small color="info"
                    v-for="(user, j) in task.instance_users"
                    :key="j"
                  >
                    {{ user.short_name }}
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions v-if="task.labels && task.labels.length" class="pa-1">
                <v-chip
                  v-for="label in task.labels"
                  small
                  :style="{ color: label.text_color, 'background-color': label.color}"
                  :key="label.name"
                >
                  {{ label.name }}
                </v-chip>
              </v-card-actions>
            </v-card>
          </router-link>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <archive-dialog ref="archiveDialog" confirm_text="Are you sure you want to delete it?" @yes="archiveTask"></archive-dialog>
  </v-layout>
</template>

<script>
  import * as mixins from '@/mixins'
  import confirm from '@/components/confirm-dialog'
  import nested from '@/components/tasks/nested'

  export default {
    name: 'TasksList',
    mixins: [mixins.removable, mixins.preloader, mixins.filter],
    props: ['data'],
    data() {
      return {
        sets: [true],
        currentTask: {},
        api: this.$api.tasks
      }
    },
    methods: {
      openRemoveModal(task) {
        this.currentTask = task
        this.$refs.archiveDialog.open()
      },
      restoreTask(task) {
        this.api.restore(task.id).then(() => {
          this.refresh()
          this.$notify({
            group: 'success',
            type: 'success',
            text: ' The task has been restored from archive'
          })
        }, err => {
          console.log('pages/projects/tasks/form.vue restoreTask', err)
        })
      },
      refresh() {
        this.$emit('refresh')
      },
      archiveTask() {
        if (!this.currentTask.id) return

        this.api.delete(this.currentTask.id).then(() => {
          this.refresh()
          this.$notify({
            group: 'success',
            type: 'success',
            text: 'The task has been archived.'
          })
        })
      },
    },
    components: {
      "archive-dialog": confirm,
      "nested-icons": nested
    }
  }
</script>
